import React from 'react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '@refinedev/core';
import { Box } from '@mui/material';
import { NavBar } from './NavBar';

export const RootLayout: React.FC = () => {
  const location = useLocation();
  const { data, isLoading } = useIsAuthenticated();
  const isAuthenticated = data?.authenticated ?? false;
  const isSplashRoute = location.pathname === '/';
  const shouldShowNavBar = isSplashRoute || (!isLoading && isAuthenticated);

  useEffect(() => {
    localStorage.setItem('currentUrl', `${location.pathname}${location.search}${location.hash}`);
  }, [location.hash, location.pathname, location.search]);

  if (!shouldShowNavBar) {
    return <Outlet />;
  }

  return (
    <>
      <NavBar />
      <Box sx={{ pt: '64px' }}>
        <Outlet />
      </Box>
    </>
  );
};
